// Mapping from GeoJSON numeric codes to ISO Alpha-2 codes
// GeoJSON uses numeric country codes, but our backend uses ISO Alpha-2 (US, CA, GB, etc.)

// export const geoToIso = {
//   // North America
//   "840": "US",  // United States
//   "124": "CA",  // Canada
//   "484": "MX",  // Mexico

//   // Europe
//   "826": "GB",  // United Kingdom (Note: sometimes stored as UK in database)
//   "276": "DE",  // Germany
//   "250": "FR",  // France
//   "380": "IT",  // Italy
//   "724": "ES",  // Spain
//   "528": "NL",  // Netherlands
//   "752": "SE",  // Sweden
//   "578": "NO",  // Norway
//   "208": "DK",  // Denmark
//   "246": "FI",  // Finland
//   "56": "BE",   // Belgium
//   "756": "CH",  // Switzerland
//   "40": "AT",   // Austria
//   "372": "IE",  // Ireland
//   "620": "PT",  // Portugal
//   "616": "PL",  // Poland
//   "203": "CZ",  // Czech Republic
//   "300": "GR",  // Greece
//   "642": "RO",  // Romania
//   "348": "HU",  // Hungary

//   // Asia
//   "392": "JP",  // Japan
//   "410": "KR",  // South Korea
//   "156": "CN",  // China
//   "356": "IN",  // India
//   "702": "SG",  // Singapore
//   "458": "MY",  // Malaysia
//   "764": "TH",  // Thailand
//   "360": "ID",  // Indonesia
//   "608": "PH",  // Philippines
//   "704": "VN",  // Vietnam

//   // Oceania
//   "36": "AU",   // Australia
//   "554": "NZ",  // New Zealand

//   // South America
//   "76": "BR",   // Brazil
//   "32": "AR",   // Argentina
//   "152": "CL",  // Chile
//   "170": "CO",  // Colombia
//   "604": "PE",  // Peru

//   // Africa
//   "710": "ZA",  // South Africa
//   "818": "EG",  // Egypt
//   "566": "NG",  // Nigeria
//   "404": "KE",  // Kenya

//   // Middle East
//   "643": "RU",  // Russia
//   "792": "TR",  // Turkey
//   "682": "SA",  // Saudi Arabia
//   "784": "AE",  // United Arab Emirates
//   "376": "IL",  // Israel

//   // Others
//   "586": "PK",  // Pakistan
//   "50": "BD",   // Bangladesh
//   "804": "UA",  // Ukraine
//   "100": "BG",  // Bulgaria
//   "191": "HR",  // Croatia
//   "688": "RS",  // Serbia
//   "703": "SK",  // Slovakia
//   "705": "SI",  // Slovenia
//   "440": "LT",  // Lithuania
//   "428": "LV",  // Latvia
//   "233": "EE",  // Estonia
//   "352": "IS",  // Iceland
//   "442": "LU",  // Luxembourg
//   "470": "MT",  // Malta
//   "196": "CY",  // Cyprus
// };
export const geoToIso = {
  // Existing entries preserved from your list
  "840": "US", "124": "CA", "484": "MX",
  "826": "GB", "276": "DE", "250": "FR", "380": "IT",
  "724": "ES", "528": "NL", "752": "SE", "578": "NO",
  "208": "DK", "246": "FI", "056": "BE", "756": "CH",
  "040": "AT", "372": "IE", "620": "PT", "616": "PL",
  "203": "CZ", "300": "GR", "642": "RO", "348": "HU",
  "392": "JP", "410": "KR", "156": "CN", "356": "IN",
  "702": "SG", "458": "MY", "764": "TH", "360": "ID",
  "608": "PH", "704": "VN",
  "036": "AU", "554": "NZ",
  "076": "BR", "032": "AR", "152": "CL", "170": "CO", "604": "PE",
  "710": "ZA", "818": "EG", "566": "NG", "404": "KE",
  "643": "RU", "792": "TR", "682": "SA", "784": "AE", "376": "IL",
  "586": "PK", "050": "BD", "804": "UA", "100": "BG", "191": "HR",
  "688": "RS", "703": "SK", "705": "SI", "440": "LT", "428": "LV",
  "233": "EE", "352": "IS", "442": "LU", "470": "MT", "196": "CY",

  // Missing countries added below
  "004": "AF",   // Afghanistan
  "008": "AL",   // Albania
  "012": "DZ",  // Algeria
  "016": "AS",  // American Samoa
  "020": "AD",  // Andorra
  "024": "AO",  // Angola
  "660": "AI", // Anguilla
  "010": "AQ",  // Antarctica
  "028": "AG",  // Antigua and Barbuda
  "051": "AM",  // Armenia
  "533": "AW", // Aruba
  "031": "AZ",  // Azerbaijan
  "044": "BS",  // Bahamas
  "048": "BH",  // Bahrain
  "112": "BY", // Belarus
  "084": "BZ",  // Belize
  "204": "BJ", // Benin
  "060": "BM",  // Bermuda
  "064": "BT",  // Bhutan
  "068": "BO",  // Bolivia
  "535": "BQ", // Bonaire
  "070": "BA",  // Bosnia & Herzegovina
  "072": "BW",  // Botswana
  "074": "BV",  // Bouvet Island
  "086": "IO",  // British Indian Ocean Territory
  "096": "BN",  // Brunei
  "854": "BF", // Burkina Faso
  "108": "BI", // Burundi
  "116": "KH", // Cambodia
  "120": "CM", // Cameroon
  "132": "CV", // Cabo Verde
  "136": "KY", // Cayman Islands
  "140": "CF", // Central African Republic
  "148": "TD", // Chad
  "162": "CX", // Christmas Island
  "166": "CC", // Cocos (Keeling) Islands
  "174": "KM", // Comoros
  "178": "CG", // Congo
  "180": "CD", // DR Congo
  "184": "CK", // Cook Islands
  "188": "CR", // Costa Rica
  "384": "CI", // Côte d'Ivoire
  "192": "CU", // Cuba
  "531": "CW", // Curaçao
  "262": "DJ", // Djibouti
  "212": "DM", // Dominica
  "214": "DO", // Dominican Republic
  "218": "EC", // Ecuador
  "222": "SV", // El Salvador
  "226": "GQ", // Equatorial Guinea
  "232": "ER", // Eritrea
  "231": "ET", // Ethiopia
  "238": "FK", // Falkland Islands
  "234": "FO", // Faroe Islands
  "242": "FJ", // Fiji
  "254": "GF", // French Guiana
  "258": "PF", // French Polynesia
  "260": "TF", // French Southern Territories
  "266": "GA", // Gabon
  "270": "GM", // Gambia
  "268": "GE", // Georgia
  "288": "GH", // Ghana
  "292": "GI", // Gibraltar
  "304": "GL", // Greenland
  "308": "GD", // Grenada
  "312": "GP", // Guadeloupe
  "316": "GU", // Guam
  "320": "GT", // Guatemala
  "831": "GG", // Guernsey
  "324": "GN", // Guinea
  "624": "GW", // Guinea-Bissau
  "328": "GY", // Guyana
  "332": "HT", // Haiti
  "334": "HM", // Heard & McDonald Islands
  "336": "VA", // Vatican
  "340": "HN", // Honduras
  "344": "HK", // Hong Kong
  "368": "IQ", // Iraq
  "364": "IR", // Iran
  "833": "IM", // Isle of Man
  "388": "JM", // Jamaica
  "400": "JO", // Jordan
  "398": "KZ", // Kazakhstan
  "296": "KI", // Kiribati
  "408": "KP", // North Korea
  "414": "KW", // Kuwait
  "417": "KG", // Kyrgyzstan
  "418": "LA", // Laos
  "422": "LB", // Lebanon
  "426": "LS", // Lesotho
  "430": "LR", // Liberia
  "434": "LY", // Libya
  "438": "LI", // Liechtenstein
  "450": "MG", // Madagascar
  "454": "MW", // Malawi
  "462": "MV", // Maldives
  "466": "ML", // Mali
  "474": "MQ", // Martinique
  "478": "MR", // Mauritania
  "480": "MU", // Mauritius
  "175": "YT", // Mayotte
  "583": "FM", // Micronesia
  "498": "MD", // Moldova
  "492": "MC", // Monaco
  "496": "MN", // Mongolia
  "499": "ME", // Montenegro
  "500": "MS", // Montserrat
  "504": "MA", // Morocco
  "508": "MZ", // Mozambique
  "104": "MM", // Myanmar
  "516": "NA", // Namibia
  "520": "NR", // Nauru
  "524": "NP", // Nepal
  "540": "NC", // New Caledonia
  "558": "NI", // Nicaragua
  "562": "NE", // Niger
  "570": "NU", // Niue
  "574": "NF", // Norfolk Island
  "807": "MK", // North Macedonia
  "580": "MP", // Northern Mariana Islands
  "512": "OM", // Oman
  "585": "PW", // Palau
  "275": "PS", // Palestine
  "598": "PG", // Papua New Guinea
  "600": "PY", // Paraguay
  "612": "PN", // Pitcairn
  "630": "PR", // Puerto Rico
  "634": "QA", // Qatar
  "638": "RE", // Réunion
  "646": "RW", // Rwanda
  "652": "BL", // Saint Barthélemy
  "654": "SH", // Saint Helena
  "659": "KN", // Saint Kitts & Nevis
  "662": "LC", // Saint Lucia
  "663": "MF", // Saint Martin
  "666": "PM", // Saint Pierre & Miquelon
  "670": "VC", // Saint Vincent & Grenadines
  "882": "WS", // Samoa
  "674": "SM", // San Marino
  "678": "ST", // Sao Tome & Principe
  "686": "SN", // Senegal
  "690": "SC", // Seychelles
  "694": "SL", // Sierra Leone
  "702": "SG", // Singapore (already included)
  "534": "SX", // Sint Maarten
  "090": "SB",  // Solomon Islands
  "706": "SO", // Somalia
  "728": "SS", // South Sudan
  "239": "GS", // South Georgia
  "740": "SR", // Suriname
  "729": "SD", // Sudan
  "744": "SJ", // Svalbard & Jan Mayen
  "760": "SY", // Syria
  "158": "TW", // Taiwan
  "762": "TJ", // Tajikistan
  "834": "TZ", // Tanzania
  "768": "TG", // Togo
  "772": "TK", // Tokelau
  "776": "TO", // Tonga
  "780": "TT", // Trinidad & Tobago
  "788": "TN", // Tunisia
  "795": "TM", // Turkmenistan
  "796": "TC", // Turks & Caicos
  "798": "TV", // Tuvalu
  "800": "UG", // Uganda
  "858": "UY", // Uruguay
  "860": "UZ", // Uzbekistan
  "548": "VU", // Vanuatu
  "862": "VE", // Venezuela
  "092": "VG",  // British Virgin Islands
  "850": "VI", // US Virgin Islands
  "876": "WF", // Wallis & Futuna
  "732": "EH", // Western Sahara
  "887": "YE", // Yemen
  "894": "ZM", // Zambia
  "716": "ZW"  // Zimbabwe
};


// Reverse mapping (ISO to GeoJSON numeric)
export const isoToGeo = Object.fromEntries(
  Object.entries(geoToIso).map(([geo, iso]) => [iso, geo])
);


//=====get country name from country code 
const COUNTRY_NAMES = {
  "AF": "Afghanistan", "AX": "Åland Islands", "AL": "Albania", "DZ": "Algeria", "AS": "American Samoa", 
  "AD": "Andorra", "AO": "Angola", "AI": "Anguilla", "AQ": "Antarctica", "AG": "Antigua and Barbuda", 
  "AR": "Argentina", "AM": "Armenia", "AW": "Aruba", "AU": "Australia", "AT": "Austria", "AZ": "Azerbaijan", 
  "BS": "Bahamas", "BH": "Bahrain", "BD": "Bangladesh", "BB": "Barbados", "BY": "Belarus", "BE": "Belgium", 
  "BZ": "Belize", "BJ": "Benin", "BM": "Bermuda", "BT": "Bhutan", "BO": "Bolivia", 
  "BQ": "Bonaire, Sint Eustatius and Saba", "BA": "Bosnia and Herzegovina", "BW": "Botswana", 
  "BV": "Bouvet Island", "BR": "Brazil", "IO": "British Indian Ocean Territory", "BN": "Brunei Darussalam", 
  "BG": "Bulgaria", "BF": "Burkina Faso", "BI": "Burundi", "KH": "Cambodia", "CM": "Cameroon", "CA": "Canada", 
  "CV": "Cabo Verde",
  "KY": "Cayman Islands",
  "CF": "Central African Republic",
  "TD": "Chad",
  "CL": "Chile",
  "CN": "China",
  "CX": "Christmas Island",
  "CC": "Cocos (Keeling) Islands",
  "CO": "Colombia",
  "KM": "Comoros",
  "CG": "Congo",
  "CD": "Congo (Democratic Republic of the)",
  "CK": "Cook Islands",
  "CR": "Costa Rica",
  "CI": "Côte d'Ivoire",
  "HR": "Croatia",
  "CU": "Cuba",
  "CW": "Curaçao",
  "CY": "Cyprus",
  "CZ": "Czech Republic",
  "DK": "Denmark",
  "DJ": "Djibouti",
  "DM": "Dominica",
  "DO": "Dominican Republic",
  "EC": "Ecuador",
  "EG": "Egypt",
  "SV": "El Salvador",
  "GQ": "Equatorial Guinea",
  "ER": "Eritrea",
  "EE": "Estonia",
  "SZ": "Eswatini",
  "ET": "Ethiopia",
  "FK": "Falkland Islands (Malvinas)",
  "FO": "Faroe Islands",
  "FJ": "Fiji",
  "FI": "Finland",
  "FR": "France",
  "GF": "French Guiana",
  "PF": "French Polynesia",
  "TF": "French Southern Territories",
  "GA": "Gabon",
  "GM": "Gambia",
  "GE": "Georgia",
  "DE": "Germany",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GR": "Greece",
  "GL": "Greenland",
  "GD": "Grenada",
  "GP": "Guadeloupe",
  "GU": "Guam",
  "GT": "Guatemala",
  "GG": "Guernsey",
  "GN": "Guinea",
  "GW": "Guinea-Bissau",
  "GY": "Guyana",
  "HT": "Haiti",
  "HM": "Heard Island and McDonald Islands",
  "VA": "Holy See",
  "HN": "Honduras",
  "HK": "Hong Kong",
  "HU": "Hungary",
  "IS": "Iceland",
  "IN": "India",
  "ID": "Indonesia",
  "IR": "Iran",
  "IQ": "Iraq",
  "IE": "Ireland",
  "IM": "Isle of Man",
  "IL": "Israel",
  "IT": "Italy",
  "JM": "Jamaica",
  "JP": "Japan",
  "JE": "Jersey",
  "JO": "Jordan",
  "KZ": "Kazakhstan",
  "KE": "Kenya",
  "KI": "Kiribati",
  "KP": "Korea (North)",
  "KR": "Korea (South)",
  "KW": "Kuwait",
  "KG": "Kyrgyzstan",
  "LA": "Lao People's Democratic Republic",
  "LV": "Latvia",
  "LB": "Lebanon",
  "LS": "Lesotho",
  "LR": "Liberia",
  "LY": "Libya",
  "LI": "Liechtenstein",
  "LT": "Lithuania",
  "LU": "Luxembourg",
  "MO": "Macao",
  "MG": "Madagascar",
  "MW": "Malawi",
  "MY": "Malaysia",
  "MV": "Maldives",
  "ML": "Mali",
  "MT": "Malta",
  "MH": "Marshall Islands",
  "MQ": "Martinique",
  "MR": "Mauritania",
  "MU": "Mauritius",
  "YT": "Mayotte",
  "MX": "Mexico",
  "FM": "Micronesia",
  "MD": "Moldova",
  "MC": "Monaco",
  "MN": "Mongolia",
  "ME": "Montenegro",
  "MS": "Montserrat",
  "MA": "Morocco",
  "MZ": "Mozambique",
  "MM": "Myanmar",
  "NA": "Namibia",
  "NR": "Nauru",
  "NP": "Nepal",
  "NL": "Netherlands",
  "NC": "New Caledonia",
  "NZ": "New Zealand",
  "NI": "Nicaragua",
  "NE": "Niger",
  "NG": "Nigeria",
  "NU": "Niue",
  "NF": "Norfolk Island",
  "MK": "North Macedonia",
  "MP": "Northern Mariana Islands",
  "NO": "Norway",
  "OM": "Oman",
  "PK": "Pakistan",
  "PW": "Palau",
  "PS": "Palestine, State of",
  "PA": "Panama",
  "PG": "Papua New Guinea",
  "PY": "Paraguay",
  "PE": "Peru",
  "PH": "Philippines",
  "PN": "Pitcairn",
  "PL": "Poland",
  "PT": "Portugal",
  "PR": "Puerto Rico",
  "QA": "Qatar",
  "RE": "Réunion",
  "RO": "Romania",
  "RU": "Russia",
  "RW": "Rwanda",
  "BL": "Saint Barthélemy",
  "SH": "Saint Helena",
  "KN": "Saint Kitts and Nevis",
  "LC": "Saint Lucia",
  "MF": "Saint Martin (French part)",
  "PM": "Saint Pierre and Miquelon",
  "VC": "Saint Vincent and the Grenadines",
  "WS": "Samoa",
  "SM": "San Marino",
  "ST": "Sao Tome and Principe",
  "SA": "Saudi Arabia",
  "SN": "Senegal",
  "RS": "Serbia",
  "SC": "Seychelles",
  "SL": "Sierra Leone",
  "SG": "Singapore",
  "SX": "Sint Maarten (Dutch part)",
  "SK": "Slovakia",
  "SI": "Slovenia",
  "SB": "Solomon Islands",
  "SO": "Somalia",
  "ZA": "South Africa",
  "GS": "South Georgia and the South Sandwich Islands",
  "SS": "South Sudan",
  "ES": "Spain",
  "LK": "Sri Lanka",
  "SD": "Sudan",
  "SR": "Suriname",
  "SJ": "Svalbard and Jan Mayen",
  "SE": "Sweden",
  "CH": "Switzerland",
  "SY": "Syrian Arab Republic",
  "TW": "Taiwan",
  "TJ": "Tajikistan",
  "TZ": "Tanzania",
  "TH": "Thailand",
  "TL": "Timor-Leste",
  "TG": "Togo",
  "TK": "Tokelau",
  "TO": "Tonga",
  "TT": "Trinidad and Tobago",
  "TN": "Tunisia",
  "TR": "Turkey",
  "TM": "Turkmenistan",
  "TC": "Turks and Caicos Islands",
  "TV": "Tuvalu",
  "UG": "Uganda",
  "UA": "Ukraine",
  "AE": "United Arab Emirates",
  "GB": "United Kingdom",
  "US": "United States",
  "UM": "United States Minor Outlying Islands",
  "UY": "Uruguay",
  "UZ": "Uzbekistan",
  "VU": "Vanuatu",
  "VE": "Venezuela",
  "VN": "Vietnam",
  "VG": "Virgin Islands (British)",
  "VI": "Virgin Islands (U.S.)",
  "WF": "Wallis and Futuna",
  "EH": "Western Sahara",
  "YE": "Yemen",
  "ZM": "Zambia",
  "ZW": "Zimbabwe"
}
;


export const getCountryName = (countryCode) => {
  if (!countryCode) return "Unknown";

  const code = countryCode.toUpperCase();
  return COUNTRY_NAMES[code] || code;
};


const countryFlags = {
  'AF': '🇦🇫', 'AX': '🇦🇽', 'AL': '🇦🇱', 'DZ': '🇩🇿', 'AS': '🇦🇸', 'AD': '🇦🇩', 'AO': '🇦🇴', 'AI': '🇦🇮', 'AQ': '🇦🇶', 
  'AG': '🇦🇬', 'AR': '🇦🇷', 'AM': '🇦🇲', 'AW': '🇦🇼', 'AU': '🇦🇺', 'AT': '🇦🇹', 'AZ': '🇦🇿', 'BS': '🇧🇸', 'BH': '🇧🇭',
  'BD': '🇧🇩', 'BB': '🇧🇧', 'BY': '🇧🇾',
  'BE': '🇧🇪', 'BZ': '🇧🇿', 'BJ': '🇧🇯', 'BM': '🇧🇲', 'BT': '🇧🇹', 'BO': '🇧🇴', 'BQ': '🇧🇶', 'BA': '🇧🇦', 'BW': '🇧🇼', 
  'BV': '🇧🇻', 'BR': '🇧🇷', 'IO': '🇮🇴', 'BN': '🇧🇳', 'BG': '🇧🇬', 'BF': '🇧🇫', 'BI': '🇧🇮', 'KH': '🇰🇭', 'CM': '🇨🇲', 
  'CA': '🇨🇦', 'CV': '🇨🇻', 'KY': '🇰🇾', 'CF': '🇨🇫', 'TD': '🇹🇩', 'CL': '🇨🇱', 'CN': '🇨🇳', 'CX': '🇨🇽', 'CC': '🇨🇨', 
  'CO': '🇨🇴', 'KM': '🇰🇲', 'CG': '🇨🇬', 'CD': '🇨🇩', 'CK': '🇨🇰', 'CR': '🇨🇷', 'CI': '🇨🇮', 'HR': '🇭🇷', 'CU': '🇨🇺', 
  'CW': '🇨🇼', 'CY': '🇨🇾', 'CZ': '🇨🇿', 'DK': '🇩🇰', 'DJ': '🇩🇯', 'DM': '🇩🇲',
  'DO': '🇩🇴',
  'EC': '🇪🇨',
  'EG': '🇪🇬',
  'SV': '🇸🇻',
  'GQ': '🇬🇶',
  'ER': '🇪🇷',
  'EE': '🇪🇪',
  'ET': '🇪🇹',
  'FK': '🇫🇰',
  'FO': '🇫🇴',
  'FJ': '🇫🇯',
  'FI': '🇫🇮',
  'FR': '🇫🇷',
  'GF': '🇬🇫',
  'PF': '🇵🇫',
  'TF': '🇹🇫',
  'GA': '🇬🇦',
  'GM': '🇬🇲',
  'GE': '🇬🇪',
  'DE': '🇩🇪',
  'GH': '🇬🇭',
  'GI': '🇬🇮',
  'GR': '🇬🇷',
  'GL': '🇬🇱',
  'GD': '🇬🇩',
  'GP': '🇬🇵',
  'GU': '🇬🇺',
  'GT': '🇬🇹',
  'GG': '🇬🇬',
  'GN': '🇬🇳',
  'GW': '🇬🇼',
  'GY': '🇬🇾',
  'HT': '🇭🇹',
  'HM': '🇭🇲',
  'VA': '🇻🇦',
  'HN': '🇭🇳',
  'HK': '🇭🇰',
  'HU': '🇭🇺',
  'IS': '🇮🇸',
  'IN': '🇮🇳',
  'ID': '🇮🇩',
  'IR': '🇮🇷',
  'IQ': '🇮🇶',
  'IE': '🇮🇪',
  'IM': '🇮🇲',
  'IL': '🇮🇱',
  'IT': '🇮🇹',
  'JM': '🇯🇲',
  'JP': '🇯🇵',
  'JE': '🇯🇪',
  'JO': '🇯🇴',
  'KZ': '🇰🇿',
  'KE': '🇰🇪',
  'KI': '🇰🇮',
  'KP': '🇰🇵',
  'KR': '🇰🇷',
  'KW': '🇰🇼',
  'KG': '🇰🇬',
  'LA': '🇱🇦',
  'LV': '🇱🇻',
  'LB': '🇱🇧',
  'LS': '🇱🇸',
  'LR': '🇱🇧',
  'LY': '🇱🇾',
  'LI': '🇱🇮',
  'LT': '🇱🇹',
  'LU': '🇱🇺',
  'MO': '🇲🇴',
  'MK': '🇲🇰',
  'MG': '🇲🇬',
  'MW': '🇲🇼',
  'MY': '🇲🇾',
  'MV': '🇲🇻',
  'ML': '🇲🇱',
  'MT': '🇲🇹',
  'MH': '🇲🇭',
  'MQ': '🇲🇶',
  'MR': '🇲🇷',
  'MU': '🇲🇺',
  'YT': '🇾🇹',
  'MX': '🇲🇽',
  'FM': '🇫🇲',
  'MD': '🇲🇩',
  'MC': '🇲🇨',
  'MN': '🇲🇳',
  'ME': '🇲🇪',
  'MS': '🇲🇸',
  'MA': '🇲🇦',
  'MZ': '🇲🇿',
  'MM': '🇲🇲',
  'NA': '🇳🇦',
  'NR': '🇳🇷',
  'NP': '🇳🇵',
  'NL': '🇳🇱',
  'NC': '🇳🇨',
  'NZ': '🇳🇿',
  'NI': '🇳🇮',
  'NE': '🇳🇪',
  'NG': '🇳🇬',
  'NU': '🇳🇺',
  'NF': '🇳🇫',
  'MP': '🇲🇵',
  'NO': '🇳🇴',
  'OM': '🇴🇲',
  'PK': '🇵🇰',
  'PW': '🇵🇼',
  'PS': '🇵🇸',
  'PA': '🇵🇦',
  'PG': '🇵🇬',
  'PY': '🇵🇾',
  'PE': '🇵🇪',
  'PH': '🇵🇭',
  'PN': '🇵🇳',
  'PL': '🇵🇱',
  'PT': '🇵🇹',
  'PR': '🇵🇷',
  'QA': '🇶🇦',
  'RE': '🇷🇪',
  'RO': '🇷🇴',
  'RU': '🇷🇺',
  'RW': '🇷🇼',
  'BL': '🇧🇱',
  'SH': '🇸🇭',
  'KN': '🇰🇳',
  'LC': '🇱🇨',
  'MF': '🇲🇫',
  'PM': '🇵🇲',
  'VC': '🇻🇨',
  'WS': '🇼🇸',
  'SM': '🇸🇲',
  'ST': '🇸🇹',
  'SA': '🇸🇦',
  'SN': '🇸🇳',
  'RS': '🇷🇸',
  'SC': '🇸🇨',
  'SL': '🇸🇱',
  'SG': '🇸🇬',
  'SX': '🇸🇽',
  'SK': '🇸🇰',
  'SI': '🇸🇮',
  'SB': '🇸🇧',
  'SO': '🇸🇴',
  'ZA': '🇿🇦',
  'GS': '🇬🇸',
  'SS': '🇸🇸',
  'ES': '🇪🇸',
  'LK': '🇱🇰',
  'SD': '🇸🇩',
  'SR': '🇸🇷',
  'SJ': '🇸🇯',
  'SE': '🇸🇪',
  'CH': '🇨🇭',
  'SY': '🇸🇾',
  'TW': '🇹🇼',
  'TJ': '🇹🇯',
  'TZ': '🇹🇿',
  'TH': '🇹🇭',
  'TL': '🇹🇱',
  'TG': '🇹🇬',
  'TK': '🇹🇰',
  'TO': '🇹🇴',
  'TT': '🇹🇹',
  'TN': '🇹🇳',
  'TR': '🇹🇷',
  'TM': '🇹🇲',
  'TC': '🇹🇨',
  'TV': '🇹🇻',
  'UG': '🇺🇬',
  'UA': '🇺🇦',
  'AE': '🇦🇪',
  'GB': '🇬🇧',
  'US': '🇺🇸',
  'UM': '🇺🇲',
  'UY': '🇺🇾',
  'UZ': '🇺🇿',
  'VU': '🇻🇺',
  'VE': '🇻🇪',
  'VN': '🇻🇳',
  'VG': '🇻🇬',
  'VI': '🇻🇮',
  'WF': '🇼🇫',
  'EH': '🇪🇭',
  'YE': '🇾🇪',
  'ZM': '🇿🇲',
  'ZW': '🇿🇼'
};



export const getCountryFlag = (countryCode) => {
  console.log(countryCode,"---countryCode---")
  if (!countryCode) return "Unknown";

  return countryFlags[countryCode] || '🌍';
};